import * as actionTypes from './actionTypes'

export const processChangeUILoading = (status) => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['ui', 'isLoading'], status),
    },
  })
